define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var cdocAdminRoles = ['CDoc Administrator'];
	var questionAdminRoles = ['Question Library Administrator'];
	var reviewAdminRoles = ['Operations Review Administrator'];
	var reviewEditRoles = reviewAdminRoles.concat(['Operations Review Editor']);
	var testRunAdminRoles = ['Test Run Administrator'];
	var testRunEditRoles = testRunAdminRoles.concat(['Test Run Editor']);

	const testRunActionAccess = {
		"Copy":access(full(testRunAdminRoles)),
		"NewTestRun":access(full(testRunAdminRoles)),
		"NewFromContractualDocument":access(full(testRunAdminRoles)),
		"NewFromTestRun":access(full(testRunAdminRoles)),
		"NewFromTemplate":access(full(testRunAdminRoles))
	};

	csiAccess.addViewRoles({
		"_CS_Data":{
			"AllContractualDocuments":{
				"NewContractualDocument":access(full(cdocAdminRoles)),
				"NewFromTestRunTemplate":access(full(cdocAdminRoles)),
				"PushToSuppliersAsReferenceCDocs":access(full(cdocAdminRoles)),
				"PushToSuppliersAsReleasedCDocs":access(full(cdocAdminRoles)),
				"UpdateSupplierCDocs":access(full(cdocAdminRoles)),
				"Delete":access(full(cdocAdminRoles))
			},
			"AllFactoryReviews":{
				"Delete":access(full(reviewAdminRoles)),
				"Edit":access(full(reviewEditRoles)),
				"GeneratePDF":access(full(reviewEditRoles)),
				"NewFactoryReview":access(full(reviewAdminRoles))
			},
			"AllSupplierReviews":{
				"Delete":access(full(reviewAdminRoles)),
				"Edit":access(full(reviewEditRoles)),
				"GeneratePDF":access(full(reviewEditRoles)),
				"NewSupplierReview":access(full(reviewAdminRoles))
			},
			"ContractualDocumentGroupsSwitchboard":{
				"NewContractualDocumentGroup":access(full(cdocAdminRoles)),
				"Copy":access(full(cdocAdminRoles)),
				"Delete":access(full(cdocAdminRoles))
			}
		},
		"_CS_QualityViews":{
			"FactoryReviewTemplates":{
				"NewFactoryReviewTemplate":access(full(questionAdminRoles))
			}
		},
		"ContractualDocumentGroup":{
			"ContractualDocuments":{
				"NewContractualDocument":access(full(cdocAdminRoles)),
				"NewFromContractualDocuments":access(full(cdocAdminRoles))
			}
		},
		"Factory":{
			"Reviews":{
				"NewFactoryReview":access(full(reviewAdminRoles))
			}
		},
		"BaseProduct": {
			"TestRuns":testRunActionAccess
		},
		"ProductColor":{
			"TestRuns":testRunActionAccess
		},
		"ProductSample":{
			"TestRuns":testRunActionAccess
		},
		"QualityAdmin":{
			"TestRunTemplates":testRunActionAccess
		},
		"Supplier":{
			"ContractualDocumentPackages":{
				"Copy":access(full(cdocAdminRoles)),
				"NewContractualDocumentPackage":access(full(cdocAdminRoles))
			},
			"SupplierContractualDocumentsHost":{
				"NewFromContractualDocument":access(full(cdocAdminRoles)),
				"NewFromContractualDocumentGroup":access(full(cdocAdminRoles)),
				"ReferenceCDoc":access(full(cdocAdminRoles)),
				"RemoveReferenceCDoc":access(full(cdocAdminRoles))
			}
		},
		"TestRunRevision":{
			"TestBySection":{
				"RevisionNewFromTestSpecs":access(full(testRunEditRoles)),
				"RevisionNewFromTests":access(full(testRunEditRoles)),
				"NewFromTestSpecs":access(full(testRunEditRoles)),
				"NewFromTests":access(full(testRunEditRoles)),
				"Copy":access(full(testRunEditRoles))
			}
		}
	});
});